(function () {
    'use strict';

    var module = angular.module('uwAgenda.agenda');

    // directive for agenda appointment online booking status
    module.directive('agendaAppointmentOnlineBooking', ['$compile', function ($compile) {
        var directive = {
            restrict: 'E',
            replace: true,
            link: link
        };
        return directive;

        function link(scope, element) {
            var el = $compile(`
                <i class="fa fa-globe" 
                   uib-tooltip="{{::'online_booking' | translate}}" 
                   tooltip-placement="auto"
                   tooltip-append-to-body="true"></i>`)(scope);
            element.append(el);           
        }
    }]);

})();